<template>
  <v-layout row justify-center>
    <v-dialog v-model="show" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{ title }}</v-card-title>
        <v-card-text>{{ message }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click="clickCancel">{{
            $t("no")
          }}</v-btn>
          <v-btn color="green darken-1" flat @click="clickConfirm">{{
            $t("yes")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: ["show", "title", "message"],
  methods: {
    clickCancel() {
      this.$emit("cancel");
    },
    clickConfirm() {
      this.$emit("confirm");
    }
  }
};
</script>
